import { render, staticRenderFns } from "./AppChrome.vue?vue&type=template&id=78c24cd0&scoped=true"
import script from "./AppChrome.vue?vue&type=script&lang=js"
export * from "./AppChrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c24cd0",
  null
  
)

export default component.exports